export default () => {
  console.log(
    `                                                                                                                                                   
                       .............     ............                
                      .#%%%%%%%%%%%/.   ,///////////*,               
                      .#%%%(///((((*.   ,//**,,,,**/*,               
                      .#%%#*    ,*,.    ,//*.    .*/*,               
                      .#%%#*    ,*,.    ,//*.    .*/*,               
                      .#%%#*    ,*,.    ,//*.    .*/*,               
                      .#%%#*    ,*,.    ,//*.    .*/*,               
                .#%%%%%%%%#*    ,*,,,,,,,**,. ,***//*,               
                .#%%%%%%%%(,    ,,,,,,,,,,,,  ,******,    

          --------------------------------------------------
          👋 Want to work with me? Email me - sam@sld.codes
          --------------------------------------------------
  `
  )
}
